// ============================================================================
//  Every instance of the CartLoad Class is initialized with a passed-in
//  props Object containing:
//
//  1. A payload, which can be any of the following:
//    - Shopify Product Object ({})
//    - Product Variant ID (Number)
//    - Serialized form data (String)
//    - Array of Shopify Product Objects
//
//  2. An optional callback function to be executed upon successful delivery of the
//     payload to the Shopify cart.
//
//  Once initialized, all the items in the payload will be automatically added
//  to the Shopify cart, and the callback will be executed.



//  PROPS TYPES
//    payload:  Product data (see description above)
//    callback: Function
// ============================================================================



export default class CartLoader {

  // ==========================================================================
  // Constructor
  // ==========================================================================

  constructor(props) {
    this.props = Object.freeze(props);

    this.addPayloadToCart();
    return this;
  }

  // ==========================================================================
  // Determines the nature of the payload, then adds the payload item(s) to the cart
  // ==========================================================================

  addPayloadToCart() {
    let dataIsJson = true;
    let data;


    if (Array.isArray(this.props.payload)) {
      data = JSON.stringify({ items: this.props.payload });
    } else if (typeof this.props.payload === 'object') {
      data = JSON.stringify({ items: [this.props.payload] });
    } else if (Number(this.props.payload) == this.props.payload) {
      data = JSON.stringify({ items: [{ id: Number(this.props.payload), quantity: 1 }] });
    } else if (typeof this.props.payload === 'string') {
      data = this.props.payload;
      dataIsJson = false;
    } else {
      this.executeCallback();
    }

    console.log('DATA!!!!');
    console.log(data);
    console.log(dataIsJson);

    this.addItemsToCart(data, dataIsJson);
  }

  // ==========================================================================
  // Adds items to the cart
  // ==========================================================================

  addItemsToCart(data, dataIsJson) {
    const self = this;

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      contentType: dataIsJson ? "application/json" : "application/x-www-form-urlencoded; charset=UTF-8",

      beforeSend: function () {
        self.beforeCartAdd();
      },

      success: function () {
        self.executeCallback();
      },

      error: function(e) {
        console.log('ERROR');
        console.log(e);
        self.executeCallback();
      }
    });
  }

  // ==========================================================================
  // Function to be executed before ATC
  // ==========================================================================

  beforeCartAdd() {
    $('.js-add-to-cart, .js-add-to-cart-bundle, .js-add-to-cart-alias').addClass('loading');
  }

  // ==========================================================================
  // Refreshesthe cart drawer. Executes the callback.
  // ==========================================================================

  executeCallback() {
    $('.js-add-to-cart, .js-add-to-cart-alias, .js-add-to-cart-bundle').removeClass('loading');

    document.dispatchEvent(new CustomEvent('cartRefresh', {
      detail: {
        openDrawer: !!this.props.openDrawer
      }
    }));

    if (typeof this.props.callback === 'function') {
      this.props.callback();
    }
  }
}
